import projectsUpsell from 'assets/images/finance/insights/projects_upsell.png'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { REQUEST_SOURCE } from 'modules/finance/components/FinancialWorkspace/consts/requestSource'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const ProjectsFilter = () => {
  return (
    <UpsellingKit.ProductWidgetPopover
      label={i18n.t(
        'finance.financial_workspace.employee_costs.header.projects_upsell.button_title'
      )}
      mediaUrl={projectsUpsell}
      variant="outlinePromote"
      title={i18n.t(
        'finance.financial_workspace.employee_costs.header.projects_upsell.modal_title'
      )}
      description={i18n.t(
        'finance.financial_workspace.employee_costs.header.projects_upsell.modal_description'
      )}
      requestSource={`${REQUEST_SOURCE} - Filter_projects`}
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_core}
      requestReason={ValidReasons.MissingAddon}
      side="bottom"
    />
  )
}
